import { createContext, useContext } from 'react'
import type { AppraiserUser, CustomerUser } from '@einwert/valuation-api-client'

export type IAmContextType = {
    signOut: () => void
    user?: CustomerUser | AppraiserUser
    isUserPending?: boolean
    isUserError?: boolean
}

export const IAmContext = createContext<IAmContextType>({
    signOut: () => {},
})

export function useIamContext() {
    const context = useContext(IAmContext)
    if (context === undefined) {
        throw new Error('IamContext must be used within a IAmContextProvider')
    }
    return context
}
